import React from 'react';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section id="oferta" className="py-8 sm:py-16 bg-[#0a1628] relative" data-id="element-113">
      <div className="max-w-4xl mx-auto px-3 sm:px-6" data-id="element-114">
        <div className="text-center mb-6 sm:mb-10" data-id="element-115">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-116">
            Oferta Especial
          </h2>
          <div className="h-1 w-20 bg-[#fbbf24] mx-auto mt-3 rounded-full" data-id="element-117"></div>
        </div>

        {/* MAIN OFFER BOX */}
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-[#fbbf24] mb-10 sm:mb-14" data-id="element-118">
          <div className="bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] py-3 sm:py-4 text-center" data-id="element-119">
            <span className="text-[#0a1628] font-black text-sm sm:text-xl tracking-wider uppercase" data-id="element-120">
              ⭐ EL KIT MÁS VENDIDO ⭐
            </span>
          </div>

          <div className="p-4 sm:p-10 text-center" data-id="element-121">
            <h3 className="text-xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6" data-id="element-122">
              Kit Completo Metodología Ciencias Sociales Lista
            </h3>

            <div className="bg-gray-50 rounded-xl p-4 sm:p-6 mb-6 text-left max-w-md mx-auto border border-gray-200" data-id="element-123">
              <p className="font-bold text-gray-700 mb-3 uppercase text-xs tracking-wide text-center" data-id="element-124">
                Incluye:
              </p>
              <ul className="space-y-2" data-id="element-125">
                {['Sistema completo (Módulos I a VI)', 'BONUS: Banco Profesional de Proyectos', 'BONUS: Planificación Anual Lista', 'Entrega digital en PDF vía Drive', 'Garantía de 7 días'].map((item, i) => <li key={i} className="flex items-center text-gray-800 font-medium text-sm" data-id="element-126">
                    <Check className="h-4 w-4 text-green-500 mr-2 flex-shrink-0" strokeWidth={3} data-id="element-127" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-center justify-center mb-4" data-id="element-128">
              <span className="text-gray-400 text-lg sm:text-2xl line-through font-medium mb-1" data-id="element-129">
                $39.990
              </span>
              <div className="relative flex items-center justify-center" data-id="element-130">
                <div className="absolute inset-0 bg-[#16a34a]/20 blur-2xl rounded-full" data-id="element-131"></div>
                <span className="relative text-[#16a34a] text-5xl sm:text-7xl font-black tracking-tight drop-shadow-[0_0_20px_rgba(21,128,61,0.5)] animate-pulse-subtle" data-id="element-132">
                  $19.990
                </span>
              </div>
              <span className="text-[#16a34a] text-lg font-bold tracking-widest uppercase mt-1" data-id="element-133">
                ARS
              </span>
            </div>

            <a href="https://pagos.docentesfelices.online/cart/50960981262642:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-lg sm:text-2xl font-black py-4 px-6 rounded-xl shadow-[0_4px_0_rgb(21,128,61)] hover:shadow-[0_2px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all uppercase mb-4" data-id="element-134">
              COMPRAR AHORA →
            </a>

            <p className="text-sm sm:text-base text-gray-600 mb-3 font-bold" data-id="element-135">
              MERCADO PAGO · TRANSFERENCIA POR WHATSAPP · DÉBITO · CRÉDITO
            </p>

            <p className="text-gray-500 text-xs sm:text-sm" data-id="element-136">
              Luego del pago, recibirás el acceso automáticamente en tu correo
              electrónico.
            </p>
          </div>
        </div>

        {/* UPSELL BOX */}
        <div className="bg-[#1e293b] rounded-2xl shadow-2xl overflow-hidden border-2 border-gray-700 relative" data-id="element-137">
          <div className="w-full text-center bg-[#dc2626] py-3" data-id="element-138">
            <span className="text-white text-sm sm:text-lg font-black uppercase tracking-widest" data-id="element-139">
              Oferta Limitada
            </span>
          </div>

          <div className="p-4 sm:p-8" data-id="element-140">
            <div className="text-center mb-6" data-id="element-141">
              <span className="inline-block bg-blue-600 text-white text-sm sm:text-lg font-bold px-5 py-1.5 rounded-full mb-4 uppercase tracking-wide shadow-md" data-id="element-142">
                Pack Profesional
              </span>
              <h3 className="text-lg sm:text-2xl font-bold text-white mb-2" data-id="element-143">
                KIT COMPLETO + SISTEMA PRO DE INVESTIGACIÓN SOCIAL APLICADA
              </h3>
              <p className="text-gray-400 text-sm sm:text-base" data-id="element-144">
                Llevá tus clases al nivel preuniversitario y elevá el análisis
                metodológico de tus estudiantes.
              </p>
            </div>

            {/* Upsell Image */}
            <div className="mb-6" data-id="element-145">
              <a href="https://pagos.docentesfelices.online/cart/50960981295410:1" className="block hover:opacity-90 transition-opacity" data-id="element-146">
                <img src="https://cdn.magicpatterns.com/uploads/kqCjEbCmmFY2d5cL97YTwf/ChatGPT_Image_4_mar_2026,_01_05_51_a.m..png" alt="Sistema Pro de Investigación Social Aplicada" className="w-full max-w-md mx-auto h-auto rounded-xl shadow-xl" data-id="element-147" />
              </a>
            </div>

            <div className="bg-[#0f172a] rounded-xl p-4 sm:p-6 mb-6 text-left max-w-lg mx-auto border border-gray-700" data-id="element-148">
              <p className="font-bold text-gray-300 mb-3 uppercase text-xs tracking-wide text-center" data-id="element-149">
                Incluye:
              </p>
              <ul className="space-y-2 grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-150">
                {['Manual avanzado de análisis estadístico aplicado', 'Cálculo paso a paso de correlación en Excel', 'Introducción práctica a regresión múltiple', 'Interpretación de p-valor', 'Intervalo de confianza explicado con ejemplos', 'Banco de bases de datos reales para practicar', 'Proyecto modelo ultra técnico resuelto', 'Manual de corrección profesional para docentes'].map((item, i) => <li key={i} className="flex items-start text-gray-300 text-xs sm:text-sm" data-id="element-151">
                    <Check className="h-4 w-4 text-[#fbbf24] mr-2 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-152" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-center justify-center mb-4" data-id="element-153">
              <span className="text-gray-500 text-lg line-through" data-id="element-154">
                $49.990
              </span>
              <div className="relative flex items-center justify-center" data-id="element-155">
                <div className="absolute inset-0 bg-[#fbbf24]/20 blur-2xl rounded-full" data-id="element-156"></div>
                <span className="relative text-[#fbbf24] text-5xl sm:text-7xl font-black tracking-tight drop-shadow-[0_0_20px_rgba(251,191,36,0.5)] animate-pulse-subtle" data-id="element-157">
                  $25.990
                </span>
              </div>
              <span className="text-[#fbbf24] text-lg font-bold tracking-widest uppercase mt-1" data-id="element-158">
                ARS
              </span>
            </div>

            <a href="https://pagos.docentesfelices.online/cart/50960981295410:1" className="block w-full max-w-md mx-auto bg-[#16a34a] hover:bg-green-700 text-white text-base sm:text-xl font-bold py-3 sm:py-4 px-6 rounded-xl shadow-lg transition-colors text-center mb-4" data-id="element-159">
              SÍ, QUIERO EL SISTEMA PRO →
            </a>

            <p className="text-sm text-gray-400 text-center font-bold" data-id="element-160">
              MERCADO PAGO · TRANSFERENCIA POR WHATSAPP · DÉBITO · CRÉDITO
            </p>
          </div>
        </div>
      </div>
    </section>;
}